import { useEffect, useRef, useState } from 'react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { pxToRem } from '@duke-hq/ui/constants/scalable';
import type { TranslatableResourceKind } from '../useContentTranslations';
import { OverrideWorkbenchData } from './OverrideWorkbenchPage';

export function OverrideWorkbenchModal({
  isOpen,
  onClose,
  resourceId,
  resourceVersionId,
  resourceKind,
  publishedVersion,
  language,
}: {
  isOpen: boolean;
  onClose: () => void;
  resourceId: string;
  resourceVersionId: number;
  resourceKind: TranslatableResourceKind;
  publishedVersion: number | null;
  // Seeds the local selection only; the in-header switcher changes it in place.
  language: string;
}) {
  const [selectedLanguage, setSelectedLanguage] = useState(language);
  useEffect(() => {
    setSelectedLanguage(language);
  }, [language]);

  // Default initial focus lands on the version chip and pops its tooltip on every
  // open; focusing the close button avoids that while keeping Esc live.
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      scrollBehavior="inside"
      initialFocusRef={closeButtonRef}
    >
      <ModalOverlay />
      <ModalContent
        w="96vw"
        maxW={pxToRem(1600)}
        h="82vh"
        my={0}
        borderRadius="xl"
        overflow="hidden"
        containerProps={{ alignItems: 'center', py: '9vh' }}
        p={0}
      >
        <OverrideWorkbenchData
          resourceId={resourceId}
          resourceVersionId={resourceVersionId}
          resourceKind={resourceKind}
          publishedVersion={publishedVersion}
          language={selectedLanguage}
          onSelectLanguage={setSelectedLanguage}
          onBack={onClose}
          closeButtonRef={closeButtonRef}
          fillHeight
        />
      </ModalContent>
    </Modal>
  );
}
